import { Alert, Box, Cards, Header, Link, SpaceBetween } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { mdiClipboardList } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useEffect, useState } from 'react';
import { buildBreadcrumbItems } from '../../pages/commons/functions';
import { useGlobalState } from '../../pages/context/GlobalStateContext';
import { CustomAppLayout } from '../../pages/index/layout';
import { useRouter } from '../../pages/index/router';

import { iconMap, MenuItem } from '../../resources/types';
import BadgeCustom from './BadgeCustom';
import Favorites from './Favorites';

type CardItem = {
    badgeVariable: string;
    badgeColor: string;
    id: string;
    text: JSX.Element;
    description: string;
    href?: string;
    items?: MenuItem[];
    icon?: string;
    isBreadcrumb?: number;
};

export interface DefaultIndexProps {
}

/**
 * Spacer - a transparent div used to add vertical spacing.
 * If `height` is provided it will be strictly interpreted as pixels.
 */
export const DefaultIndex: React.FC<DefaultIndexProps> = ({

}) => {
    const { navigate } = useRouter();
    const { menu, data } = useGlobalState();
    const [option, setOption] = useState<MenuItem | null>();
    const [badgeVariables, setBadgeVariables] = useState<string[]>([]);
    const [items, setItems] = useState<CardItem[]>([]);

    const { badgeData, getBadge, setBadge, clearBadge } = useBadgeData();

    const handleOption = (ref: string) => {
        window.location.href = ref
    }

    useEffect(() => {
        if (data && data.counters && data.counters.pax) setBadge("counterPax", data.counters.pax || 0);
        if (data && data.counters && data.counters.shifts) setBadge("counterShifts", data.counters.shifts || 0);
        if (data && data.counters && data.counters.polls) setBadge("counterPolls", data.counters.polls || 0);

    }, [data]);

    useEffect(() => {
        const matchedItems = findItemWithChildren(menu, window.location.hash);
        setOption(matchedItems);

        // Get the raw sub-items from the matched menu branch
        const rawSubItems = matchedItems?.items ?? [];
        const subItems = subItemsToItems(rawSubItems);

        if (subItems) {
            // Filter to only include items where isBreadcrumb is exactly 1
            const breadcrumbItems = subItems.filter(item => item.isBreadcrumb === 1);
            setItems(breadcrumbItems);
        } else {
            setItems([]); // Clear items if none found
        }

    }, [menu]);

    useEffect(() => {
        //console.log(items)
    }, [option]);

    return (
        <CustomAppLayout
            toolsHide={true}

            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction='vertical' size='m'>
                        <Alert
                            action={<Favorites />}
                            type="info"
                            header={option?.text}
                        >
                            {option?.description}
                        </Alert>
                        <Cards
                            //selectionType="single"
                            cardDefinition={{

                                //header: item => item?.text || "Sin nombre",
                                sections: [
                                    {
                                        content: item => (<>
                                            <div onClick={() => { window.location.hash = item.href || window.location.hash }}>
                                                <Header variant='h3' actions={
                                                    <>
                                                        {item.badgeVariable !== "" && badgeData[item.badgeVariable] && badgeData[item.badgeVariable] > 0 && (
                                                            <>
                                                                <BadgeCustom color={item.badgeColor || "grey"}>{badgeData[item.badgeVariable] * 1}</BadgeCustom>
                                                            </>
                                                        )}
                                                        <Icon path={iconMap[item.icon || ""] || "" as string} size={1.5} />
                                                    </>
                                                }><>
                                                        <Link fontSize="heading-l" href={item.href}>{item?.text || "Sin nombre"}</Link>
                                                    </></Header>
                                                <Box>{item.description}</Box>

                                            </div>
                                        </>)
                                    },
                                ]
                            }}
                            onSelectionChange={() => console.log('selection change')}
                            cardsPerRow={[
                                { cards: 1 },
                                { minWidth: 800, cards: 3 },
                                { minWidth: 500, cards: 2 }
                            ]}
                            entireCardClickable
                            items={items}
                        />
                    </SpaceBetween>
                </>
            }
        />
    );
};


const findItemWithChildren = (items: MenuItem[], hash: string): MenuItem | null => {
    for (const item of items) {
        if (item.href === hash) {
            // Found the target, return a shallow copy including its children
            return { ...item };
        }
        if (item.items) {
            const found = findItemWithChildren(item.items, hash);
            if (found) return found;
        }
    }
    return null;
};


const subItemsToItems = (subItems: MenuItem[]) => {
    return subItems.map((item) => {
        const iconPath = iconMap[item.icon || ""] || mdiClipboardList;
        return {
            id: item.href || item.idMenu?.toString() || 'unknown-id', // always string
            href: item.href,
            text: <span>{item.text || "Sin nombre"}</span>,
            description: item.description || "",
            icon: item.icon || "",
            badgeColor: item.badgeColor || "",
            badgeVariable: item.badgeVariable || "",
            isBreadcrumb: item.isBreadcrumb,


        };
    });
};


function useBadgeData() {
    const [badgeData, setBadgeData] = useState<Record<string, number>>({});

    const getBadge = (key: string): number | undefined => badgeData[key];

    const setBadge = (key: string, value: number) => {
        setBadgeData(prev => ({ ...prev, [key]: value }));
    };

    const clearBadge = (key: string) => {
        setBadgeData(prev => {
            const updated = { ...prev };
            delete updated[key];
            return updated;
        });
    };

    return { badgeData, getBadge, setBadge, clearBadge };
}